import React from 'react';
import { Sharing, WhishlistButton } from 'iovisit-theme/components/Views';

interface PageActionsProps {
  content: object;
  showWhishlist: boolean;
  showLabel: boolean;
}

const PageActions: React.FC<PageActionsProps> = ({
  content,
  showWhishlist = true,
  showLabel = false,
}) => {
  return content ? (
    <div className="page-actions">
      {showWhishlist && __CLIENT__ && (
        <WhishlistButton id={content['UID']} showLabel={showLabel} />
      )}

      <Sharing
        url={content['@id']}
        title={content.title}
        showLabel={showLabel}
      />
    </div>
  ) : (
    <></>
  );
};
export default PageActions;
